import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';
import GroupNodePlaceholder from './components/GroupNodePlaceholder';
import type { GroupNodeProps } from './components/GroupNode';
import type { GroupListProps } from './components/GroupList';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "GroupListView" */ './lazyIndex'),
    { name: 'GroupListView' }
);

// Export delay loaded components
export const GroupList: LazyComponent<GroupListProps, HTMLDivElement, void> = createLazyComponent(
    lazyModule,
    m => m.GroupList
);
export const GroupNode: LazyComponent<GroupNodeProps, HTMLDivElement, HTMLDivElement> =
    createLazyComponent(lazyModule, m => m.GroupNode, GroupNodePlaceholder);
